export default "__VITE_PUBLIC_ASSET__02587db7__"